const getDialogCenterPosition = (dialogWidth: number, dialogHeight: number) => ({
  left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - dialogWidth / 2,
  top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - dialogHeight / 2,
});

const openNetworkShareDialog = (url: string): void => {
  const config = {
    height: 400,
    width: 550,

    ...getDialogCenterPosition(550, 400),

    location: 'no',
    menubar: 'no',
    resizable: 'no',
    scrollbars: 'yes',
    status: 'no',
    toolbar: 'no',
  };

  window.open(
    url,
    '',
    Object.entries(config)
      .map(([key, value]) => `${key}=${value}`)
      .join(','),
  );
};

export { openNetworkShareDialog };
